import { BsGithub, BsTwitter } from "react-icons/bs";
import { DiCss3, DiJavascript1, DiReact } from "react-icons/di";
import { SiGmail } from "react-icons/si";
import "./footer.css";

const Footer = () => {
  return (
    <>
      <div className="footerContainer">
        <div className="contactIconContainer">
          {/* <a
            href="https://www.linkedin.com/in/sonu-bardai/"
            target="_blank"
            rel="noreferrer"
          >
            <BsLinkedin className="contactIcons" />
          </a> */}
          <a
            href="https://twitter.com/SonuBardai"
            target="_blank"
            rel="noreferrer"
          >
            <BsTwitter className="contactIcons" />
          </a>
          <a
            href="https://github.com/SonuBardai"
            target="_blank"
            rel="noreferrer"
          >
            <BsGithub className="contactIcons" />
          </a>
          <a
            href="mailto:sonubardai9@gmail.com"
            target="_blank"
            rel="noreferrer"
          >
            <SiGmail className="contactIcons" />
          </a>
        </div>
        <div className="footerMadeWith">
          Website Made with ReactJS <DiReact className="footerIcon" />
          , Vanilla CSS <DiCss3 className="footerIcon" />, Javascript{" "}
          <DiJavascript1 className="footerIcon" />, and lots of{" "}
          <img
            src={process.env.PUBLIC_URL + "/heart.png"}
            alt="love"
            className="love"
          />
        </div>
        <div className="footerText">
          &#169; 2022 All rights reserved - Designed & Coded by Sonu Bardai
        </div>
      </div>
    </>
  );
};

export default Footer;
